// src/main.ts
import { APP_INITIALIZER, isDevMode } from '@angular/core';
import { bootstrapApplication } from '@angular/platform-browser';
import { provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';

import { AppComponent } from './app/app.component';
import { appConfig } from './app/app.config';
import { routes } from './app/app.routes';
import { provideServiceWorker } from '@angular/service-worker';
import { provideRouter, withInMemoryScrolling, withRouterConfig } from '@angular/router';



// Bootstrap with APP_INITIALIZER
bootstrapApplication(AppComponent, {
  ...appConfig,
  providers: [
    provideRouter(routes, withRouterConfig({ onSameUrlNavigation: 'reload' }),withInMemoryScrolling({
    anchorScrolling: 'enabled',
    scrollPositionRestoration: 'enabled',
  })),
    ...(appConfig.providers || []),

    provideHttpClient(withInterceptorsFromDi()),
    // provideServiceWorker('ngsw-worker.js', {
    //         enabled: !isDevMode(),
    //         registrationStrategy: 'registerWhenStable:30000'
    //       }),
  ]
}).catch(err => console.error(err));
